/**
 * 签证类
 */
export default class Visa {
  constructor(visa = {}) {
    Object.assign(this, visa)
  }

  // 电子签的 不用显示寄回信息  快递费 和补填寄送信息这些
  get showAddress() {
    return this.visaForm !== '0'
  }
}
